export default class CustomError extends Error {
  constructor(details, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }

    this.status = details.status;
    this.name = 'CustomError';
    // Custom debugging information
    this.details = details;
    this.date = new Date();
  }
}
